export const dateToWorkingHours = {
  formatTime,
  checkTime
};

function formatTime(time) {
  const hours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
  const minutes = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
  return hours + ':' + minutes;
}

function checkTime(type, startOrEnd) {
  if (type && type[startOrEnd] && type[startOrEnd] instanceof Date) {
    type[startOrEnd] = this.formatTime(type[startOrEnd]);
  } else if (type && type[startOrEnd] && type[startOrEnd].length > 5) {
    const date = new Date(type[startOrEnd]);
    type[startOrEnd] = this.formatTime(date);
  }
}


// WEBPACK FOOTER //
// ./src/helpers/dateToWorkingHours.js